import styled from 'styled-components';
import { HEADER_HEIGHT } from 'components/Page/Header/TopHeader/TopHeader';
import { Divider as AntDivider, Flex, Modal, MODAL_HEADER_HEIGHT } from 'UI';
import { Menu } from 'UI/Menu/Menu';

export const SMenu = styled(Menu)`
  border: none !important;

  div.ant5-menu-submenu-title {
    height: 60px !important;
    border-radius: 0px !important;
    border-bottom: solid 1px ${({ theme }) => theme.color.grey85};
    font-size: 20px;
    font-family: 'NouvelR';
    font-weight: 500;
    margin: 0px !important;
    padding: 0px !important;
    padding-right: 34px !important;
    padding-left: 5px !important;
    width: auto;
  }

  li.ant5-menu-submenu-selected > div.ant5-menu-submenu-title {
    color: inherit !important;
    background-color: #0000000f !important;
    font-weight: 500 !important;
    margin: 0px !important;
  }

  .ant5-menu-item {
    width: auto;
    height: 40px !important;
    border-radius: 0px !important;
    font-size: 14px;
    font-family: 'NouvelR';
    font-weight: 500;
    margin: 0px !important;
    padding: 0px 16px 0px 25px !important;
    background-color: rgba(0, 0, 0, 0.02) !important;
  }

  li.ant5-menu-item-selected {
    color: inherit !important;
    background-color: #00000026 !important;
  }

  .ant5-menu-item.ant5-menu-item-active:not(.ant5-menu-item-selected) {
    background-color: #0000000f !important;
  }

  .ant5-menu-sub {
    background-color: inherit !important;
    max-height: 360px !important;
  }

  .ant5-menu-submenu-open > ul:not(.ant5-motion-collapse) {
    overflow-y: auto !important;
  }
`;

export const SModal = styled(Modal)`
  .ant5-modal-body > div {
    margin: 0px !important;
  }

  .ant5-modal-content {
    height: ${() => `calc(100vh - ${HEADER_HEIGHT}px) !important`};
    overflow-y: auto;
    border-bottom-right-radius: 0px !important;
    border-top-right-radius: 0px !important;
  }

  position: absolute;
  right: 8px;
  top: ${() => `${HEADER_HEIGHT - MODAL_HEADER_HEIGHT}px !important`};
  max-width: 800px;
`;

export const SDivider = styled(AntDivider)`
  margin: 2px -24px 0px -24px !important;
  width: auto;
`;

export const SFlex = styled(Flex)`
  margin: 0;
  height: auto !important;
  flex: 1;
`;
